import React from "react";
import { useTranslation } from "react-i18next";
import { Settings } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../ui/card";
import { Input } from "../../../ui/input";
import { Label } from "../../../ui/label";

const TunisiaAccountingCard = ({ formData, handleInputChange }) => {
  const { t } = useTranslation();
  return (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Settings className="h-5 w-5" />
        {t("payrollTN.acctTitle")}
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <Label htmlFor="gl_salary">{t("payrollTN.glSalary")}</Label>
          <Input
            id="gl_salary"
            value={formData.gl_salary_account}
            onChange={(e) => handleInputChange("gl_salary_account", e.target.value)}
            placeholder="6411"
          />
        </div>

        <div>
          <Label htmlFor="gl_payable">{t("payrollTN.glPayable")}</Label>
          <Input
            id="gl_payable"
            value={formData.gl_payable_account}
            onChange={(e) => handleInputChange("gl_payable_account", e.target.value)}
            placeholder="4281"
          />
        </div>

        <div>
          <Label htmlFor="gl_cnss">{t("payrollTN.glCnss")}</Label>
          <Input
            id="gl_cnss"
            value={formData.gl_cnss_account}
            onChange={(e) => handleInputChange("gl_cnss_account", e.target.value)}
            placeholder="4291"
          />
        </div>
      </div>
    </CardContent>
  </Card>
  );
};

export default TunisiaAccountingCard;
